module.exports = __webpack_public_path__ + "img/type-orange.3777584e.png";